import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import globalText from "../../../../utils/globalText";

const TaxationTransactionFailed = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { createTdsTransactionError } = useSelector(
    (state) => state.createTdsTransaction,
  );

  const sessionError = sessionStorage.getItem("tax_txn_error");
  let parsedSessionError = null;

  try {
    parsedSessionError = sessionError ? JSON.parse(sessionError) : null;
  } catch (e) {
    parsedSessionError = sessionError;
  }

  const errorSource = createTdsTransactionError || parsedSessionError;

  const extractErrorMessages = (errors) => {
    const messages = [];

    const recurse = (value) => {
      if (Array.isArray(value)) value.forEach(recurse);
      else if (typeof value === "object" && value !== null)
        Object.values(value).forEach(recurse);
      else if (typeof value === "string") messages.push(value);
    };

    recurse(errors);
    return messages;
  };

  const getErrorMessages = (errorSource) => {
    if (!errorSource) return [];

    if (errorSource?.errors) {
      return extractErrorMessages(errorSource.errors);
    }

    if (typeof errorSource === "string") {
      return [errorSource];
    }

    if (typeof errorSource === "object") {
      return extractErrorMessages(errorSource);
    }

    return ["Transaction failed"];
  };

  const errorMessages = getErrorMessages(errorSource)?.filter(Boolean) || [
    "Transaction failed. Please try again.",
  ];

  const buttonRows = [
    [
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: ICONS?.ADD_BUTTON,
        imgColor: "var(--negative-bg)",
        handleFunction: () => {
          sessionStorage.removeItem("tax_txn_error");
          navigate("/tax_transaction_dashboard/create_tax_transaction");
        },
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--negative-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => {
          sessionStorage.removeItem("tax_txn_error");
          navigate("/tax_transaction_dashboard");
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));
    dispatch(disableSwitcher());

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  return (
    <StatusContainer
      status="error"
      title={globalText?.TAX_TRANSACTION_CREATION_FAILED}
      buttonRows={buttonRows}
    >
      <TabsWeapperSection title="Error details">
        <>
          {errorMessages.length ? (
            errorMessages.map((msg, index) => (
              <InfoCard
                key={index}
                bgColor="var(--negative-card)"
                rows={[
                  {
                    leftTitle: msg,
                    leftSubTitle: "Error message",
                  },
                ]}
              />
            ))
          ) : (
            <InfoCard
              bgColor="var(--negative-card)"
              rows={[
                {
                  leftTitle: "Transaction failed",
                  leftSubTitle: "Unknown error",
                },
              ]}
            />
          )}
        </>
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default TaxationTransactionFailed;
